export enum Keys {
    None = 0,
    Up = 6,
    Down = 7,
    Right = 8,
    Left = 9,
    Tquery = 29,
    Total = 30,
    Refresh = -58,
    SaveRow = 78,
    SEND_LABELS = -46,
    FormHelp = 57
}
